exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* For GDPR banner component */\nbody.gdprCookieBanner-acceptedAll {\n  height: auto;\n  margin-bottom: 14em;\n}\n@media only screen and (max-width: 500px) {\n  /* For mobile phones: */\n  body.gdprCookieBanner-acceptedAll {\n    margin-bottom: 18em;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/less-loader!../node_modules/xo-page-components/src/gdprCookieBanner/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!../node_modules/xo-page-components/src/gdprCookieBanner/styles.less
// module chunks = 0